export const settingsWorkspaceRoutes = {
  groups: '/settings/workspace/groups',
  groupDetail: '/settings/workspace/groups/:groupId',
  workspace: '/settings/workspace',
  setting: '/settings/workspace/workspace',
  role: '/settings/workspace/role',
  roleForm: '/settings/workspace/role-form',
  memberInvitation: '/settings/workspace/member-invitation',
  members: '/settings/workspace/members',
  membersOngoingInvitation: '/settings/workspace/members/ongoing-invitation',
  automaticSharing: '/settings/workspace/automatic-sharing',
} as const;
